module.exports = __webpack_public_path__ + "static/media/token1.d371ca84.svg";